// app/frontend/lib/fileUpload.ts
// Shared file upload constants and utilities

export const MAX_FILE_SIZE = 10 * 1024 * 1024 // 10MB

export const ALLOWED_FILE_TYPES = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
  'application/pdf',
  'text/plain',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
] as const

export type AllowedFileType = typeof ALLOWED_FILE_TYPES[number]

export function isAllowedFileType(type: string): type is AllowedFileType {
  return ALLOWED_FILE_TYPES.includes(type as AllowedFileType)
}

export function isFileSizeAllowed(size: number): boolean {
  return size <= MAX_FILE_SIZE
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}

export const ALLOWED_FILE_TYPES_DISPLAY = 'images, PDF, TXT, DOC'

/** Extract the first file from a paste event's clipboardData, if present. */
export function extractPastedFile(clipboardData: DataTransfer): File | null {
  for (const item of Array.from(clipboardData.items)) {
    if (item.kind !== 'file') continue
    const file = item.getAsFile()
    if (file) return file
  }
  return null
}
